import React from "react";
import { Header, Faq, SubFooter } from "Atoms/";

export default function faq() {
  return (
    <>
      <Header
        classType="header-int"
        title1="ʻĪao Valley"
        title2="State Monument"
        url="iao-valley"
      />
      <div className="container" role="main">
        <div className="row row-padding">
          <div className="col-xl-12">
            <h2>FAQ about ʻĪao Valley State Monument</h2>
            <p>
              <hr />
              <h3 className="h4 fw-bold">What time does the park open? </h3>
              Reservations begin at 7am.{" "}
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">When is the last reservation? </h3>
              The last reservation is at 4:30 pm. You must enter the park no later than 5 pm.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">How long is the typical visit? </h3>
              Typically, a visit lasts from 30 to 60 minutes.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">When do I need to leave the park? </h3>
              At the end of your reservation time.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                Do I need a reservation and purchase my parking and/or entry fees
                before I arrive?{" "}
              </h3>
              Yes.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">I have young children. Do I need to pay for them also? </h3>
              Children three (3) years old or younger do not need to pay.{" "}
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Do you accept visitors without reservations? </h3>
              No. Anyone without a reservation will be turned away (except local
              residents with valid Hawaiʻi State ID).{" "}
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Do you offer military discounts? </h3>
              Unfortunately, at this time, we do not.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                When I made my reservation, it was only two of us. Now my three
                kids want to go. What can I do?{" "}
              </h3>
              If it is before your reservation start time, you can return to the
              reservation website and purchase the appropriate number of
              additional entry tickets – if space is available. You will be
              charged at that point for the extra visitors in your party.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I have reservations, but due to a scheduling conflict, can no longer make it. What can I do?{" "}
              </h3>
              Please return to the reservation website and see if you can cancel or modify your reservations (feature available prior to 3 days before your check-in). Cancellation fees may apply.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I have reservations today, but it is raining. Can I get a refund?{" "}
              </h3>
              No, we do not offer refunds due to the weather or any other conditions outside of our control, unless there is an official park closure due to hazardous conditions or emergency.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am bringing my family to the park, but I am unable to physically walk. Do I still have to pay an entry fee?{" "}
              </h3>
              Yes. Anyone entering the park needs to purchase an entry ticket.  
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                Originally, when I made the reservations and purchased my entry tickets, it was for myself, my wife and two children. Now my two children want to go to the beach instead. Can I bring two of my relatives in their place?{" "}
              </h3>
              Yes, as long as you do not exceed the number of entries on the ticket.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am a kamaʻāina, do I need a reservation, and must I purchase
                parking and entry fees?{" "}
              </h3>
              Reservations are not required for all kamaʻāina with valid identification issued by the State of Hawaiʻi. Proceed to the entry point and show your Hawaiʻi Driver’s License or ID.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am a kamaʻāina and I have out of state guests with me. Do they
                need a reservation?{" "}
              </h3>
              Yes, your guests require reservations and must purchase parking and/or entry tickets. Please do not bring them to the park without confirmed reservations, as they will be denied entry.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
               I live in the state now, but I do not yet have a Hawaiʻi issued ID. Do I need to make a reservation and purchase entry tickets?
              </h3>
              Yes. Once you receive your official Hawaiʻi ID, you will no longer need a reservation or to pay.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am a kamaʻāina and I have a Hawaiʻi issued ID, does this guarantee me a parking spot?{" "}
              </h3>
              No. We reserve a portion of our parking lot for kamaʻāina. But we cannot guarantee a spot. We will do our best to accommodate you. But you may be turned away, if no parking is available. Residents who walk in will always be accommodated.
            </p>
          </div>
        </div>
      </div>
      <SubFooter name="ʻĪao Valley State Monument" url="iao-valley" />
    </>
  );
}
